export const optionAll = {
    // 工时统计
    workHourAnalysis:{
        apiKey:'details',
        title:'详细数据',
        msg:'',
        column: [
            {
                label: "员工姓名",
                prop: "leaderName",
                overHidden: true,
                type: "select",
                search: true,
            },
            {
                label: '所属班组',
                prop: 'teamName',
                search: true,
            },
            {
                label: '日期',
                prop: 'createTime',
            },
            {
                label: '工时数',
                prop: 'actualWorkHours',
            },
            {
                label: '任务名称',
                prop: 'orderName',
            },
        ]
    },
    // 任务完成率
    taskCompletion:{
        apiKey: 'task-details',
        title: '任务明细',
        msg: '',
        column: [
            {
                label: "任务名称",
                prop: "orderName",
                overHidden: true,
                type: "select",
                search: true,
            },
            {
                label: '负责人',
                prop: 'leaderName',
            },
            {
                label: '计划开始时间',
                prop: 'planStartTime',
            },
            {
                label: '计划完成时间',
                prop: 'planEndTime',
            },
            {
                label: '实际完成时间',
                prop: 'actualEndTime',
            },
        ]
    },
    // 人均产出
    perCapitaOutput:{
        apiKey:'output-details',
        title: '产出明细',
        msg: '',
        column: [
            {
                label: "员工姓名",
                prop: "leaderName",
                overHidden: true,
                type: "select",
                search: true,
            },
            {
                label: '所属部门',
                prop: 'deptName',
            },
            {
                label: '班组名称',
                prop: 'teamName',
            },
            {
                label: '总产出值',
                prop: 'totalWorkHours',
            },
        ]
    },
    // 效率排名
    efficiencyRanking:{
        apiKey:'efficiency-ranking-details',
        title: '效率排名明细',
        msg: '各班组执行任务不同，建议排行以班组为单位，一般组一排行',
        column: [
            {
                label: '排名',
                prop: 'rank',
            },
            {
                label: "员工姓名",
                prop: "employeeName",
                overHidden: true,
                type: "select",
                search: true,
            },
            {
                label: '所属班组',
                prop: 'teamName',
            },
            {
                label: '综合得分率(%)',
                prop: 'comprehensiveEfficiency',
            },
            {
                label: '按时完成率(%)',
                prop: 'onTimeCompletionRate',
            },
            {
                label: '工单效率执行率(%)',
                prop: 'workOrderExecutionEfficiency',
            },
            {
                label: '工单完成数量',
                prop: 'completedOrderCount',
            },
        ]
    }
}